export default {
    downtimeUrl: "https://cl.kodland.tech",
    new_social_proof: true,
    startPage: {
      image: {
        url:  "/welcome/quiz_turkey_free_corse_social_proof_pk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      imageMobile: "/welcome/quiz_turkey_free_corse_social_proof_mobile.png",
      title: "Şimdi kaydolun, çocuğunuz çevrimiçi eğitim platformu Kodland'de ücretsiz bir programlama kursu alsın!",
      subtitle:
        "Bu çevrimiçi kursta çocuklar temel programlama becerilerini öğrenecek ve ilk projelerini oluşturacaklar. Profesyonel bir öğretmenle 3 online dersinizi ve canlı bireysel oturumunuzu alın!",
      button: "Üye ol",
    },
      stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
      1: {
        question: "Çocuğunuz genellikle boş zamanlarını nasıl geçirir?",
        answers: [
          "🎮 Cep telefonu ve bilgisayarda oyun oynar",
          "🎨 Sanatsal faaliyetlerde bulunur: çizim, müzik, oyunculuk",
          "⚽️ Spor yapar",
          "🏕️ Ailesiyle vakit geçirir",
          "👀 Çizgi film izler",
          "🤝 Arkadaşlarıyla sosyalleşir",
        ],
      },
      2: {
        question: "Çocuğunuzun okulda en sevdiği ders hangisidir?",
        subtitle: "Eğitim uzmanımızla yapacağınız profil oluşturma oturumu çocuğunuzun yeni becerilerinin ortaya çıkarılmasına yardımcı olacak ve çocuğunuzun gelişimi için en uygun kursa karar verilmesine yardımcı olacak.",
        answers: [
          "🔬 Fen bilimleri",
          "🎨 Sanat ve tasarım",
          "💻 Bilgisayar bilimi",
          "📙 Tarih, Edebiyat",
          "📐 Matematik",
          "💬 Yabancı diller",
          "🤩 Tüm dersler",
          "🤔 Emin değilim",
        ],
      },
      3: {
        title: "Deneme dersi için hangi saatte uygunsunuz?",
        type: "timeslot",
        subtitle:
          "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
        button: "Rezervasyon için tıklayın 🎁",
      },
      4: {
        question: "Çocuğunuzun herhangi bir bilgisayar becerisi var mı?",
        subtitle: "Çocuğunuzun hiç kodlama deneyimi yoksa bile biz öğretebiliriz!<p>Öğrencilerimiz 1 dersten sonra kendi oyunlarını üretmeye başlıyor!",
        answers: [
          "😌 Evet, Microsoft Word/PowerPoint",
          "🖥 Evet, temel kodlama",
          "👍 Evet, oyun oynamayı sever (Roblox, Minecraft)",
          "🤔 Hayır",
        ],
      },
      5: {
        question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
        subtitle: "Kodlama öğrenimi için dizüstü veya masaüstü bir bilgisayara ihtiyacınız bulunmaktadır.",
        answers: [
          {
            answer: "💻 Evet",
            distribution_tag_question: [18],
          },
          {
            answer: "😐 Hayır",
            stopAnswer: true
          },
        ],
      },
      6: {
        title: "Çocuğunuz kaç yaşında?",
        type: "age",
        subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz. Lütfen çocuğunuzun doldurduğu yaşı seçin.",
        button: "İleri 🚀",
      },
      7: {
        title: "Çocuğunuzun adı nedir?",
        type: "child_name",
        subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
        button: "İleri 🚀",
      },
      8: {
        title: "E-postanızı girin",
        type: "mail",
        subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
        button: "İleri 🚀",
      },
      9: {
        title: "Telefon numaranızı girin",
        type: "phone",
        subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
        button: "Neredeyse bitti 🔥",
      },
      10: {
        title: "İsminizi girin",
        type: "parent_name",
        subtitle: "Bizim adımız Kodland, sizinki ne?👋",
        button: "Son adım! 🎉",
      },
    },
  };
  
